import React from 'react';
import { Box, Stack } from '@mui/material';

import { GenderDistributionChart } from './resort-statistics/GenderDistributionChart';
import { ParticipantsAgeDistributionChart } from './resort-statistics/ParticipantsAgeDistributionChart';
import { GeneralSalesChart } from './resort-statistics/GeneralSalesChart';
import { OrderDistributionChart } from './resort-statistics/OrderDistributionChart';

export const ResortStatistics = props => {
  const { data } = props;

  return (
    <Stack direction="column">
      <Stack direction="row">
        <Box flex="1 1 40%">
          <GenderDistributionChart data={data.gender_distribution} />
        </Box>
        <Box flex="1 1 60%">
          <OrderDistributionChart data={data.orders} />
        </Box>
      </Stack>
      <Box flex="1 1 60%">
        <ParticipantsAgeDistributionChart data={data.participants_age_distribution} />
      </Box>
      <Stack>
        <Box>
          <GeneralSalesChart data={data.general_sales} />
        </Box>
      </Stack>
    </Stack>
  );
};
